import { CENTER_DEFAULT } from './schemaDefaults/center';
import { FULL_WIDTH_DEFAULT } from './schemaDefaults/fullWidth';
import { MONOGRAM_DEFAULT } from './schemaDefaults/monogram';
import { NO_PHOTO_DEFAULT } from './schemaDefaults/noPhoto';
import { PAGE_WIDTH_DEFAULT } from './schemaDefaults/pageWidth';
import { PHOTO_ARCH_DEFAULT } from './schemaDefaults/photoArch';
import { PHOTO_DUO_LEFT_DEFAULT } from './schemaDefaults/photoDuoLeft';
import { PHOTO_DUO_RIGHT_DEFAULT } from './schemaDefaults/photoDuoRight';
import { PHOTO_MARQUEE_DEFAULT } from './schemaDefaults/photoMarquee';
import { PHOTO_MARQUEE_PAGE_WIDTH_DEFAULT } from './schemaDefaults/photoMarqueePageWidth';
import { PHOTO_BACKGROUND_DEFAULT } from './schemaDefaults/photoBackground';
import { PHOTO_BACKGROUND_MONOGRAM_DEFAULT } from './schemaDefaults/photoBackgroundMonogram';
import { VIDEO_BACKGROUND_DEFAULT } from './schemaDefaults/videoBackground';
import { VIDEO_BACKGROUND_MONOGRAM_DEFAULT } from './schemaDefaults/videoBackgroundMonogram';
import { VIDEO_ARCH_DEFAULT } from './schemaDefaults/videoArch';
import { PHOTO_SLIDER_DEFAULT } from './schemaDefaults/photoSlider';
import { PHOTO_SLIDER_PAGE_WIDTH_DEFAULT } from './schemaDefaults/photoSliderPageWidth';
import { PHOTO_TRIO_DEFAULT } from './schemaDefaults/photoTrio';
import { PHOTO_TRIO_PAGE_WIDTH_DEFAULT } from './schemaDefaults/photoTrioPageWidth';
import { SCHEMA_URL_BY_WEBSITE_LAYOUT } from './schemaUrlByLayout.constants';

export const DEFAULT_HEADER_PRESENTATION_LAYOUT_BY_WEBSITE_LAYOUT: Record<string, string> = {
  aloha: 'center',
  brannan: 'noPhoto',
};

// URLs come from the lightweight `SCHEMA_URL_BY_WEBSITE_LAYOUT` (single source of truth); this map
// pairs each with its default `template` object. Consumers that only need URL strings should import
// the lightweight map directly to avoid pulling in the heavy `schemaDefaults/*` modules.
export const PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT = {
  aloha: {
    center: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.aloha.center,
      template: CENTER_DEFAULT,
    },
    photoSlider: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.aloha.photoSlider,
      template: PHOTO_SLIDER_DEFAULT,
    },
  },
  brannan: {
    monogram: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.monogram,
      template: MONOGRAM_DEFAULT,
    },
    center: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.center,
      template: CENTER_DEFAULT,
    },
    fullWidth: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.fullWidth,
      template: FULL_WIDTH_DEFAULT,
    },
    pageWidth: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.pageWidth,
      template: PAGE_WIDTH_DEFAULT,
    },
    photoSlider: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoSlider,
      template: PHOTO_SLIDER_DEFAULT,
    },
    photoSliderPageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSliderPageWidth-v1_0_0.json',
      template: PHOTO_SLIDER_PAGE_WIDTH_DEFAULT,
    },
    photoTrio: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoTrio,
      template: PHOTO_TRIO_DEFAULT,
    },
    photoTrioPageWidth: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoTrioPageWidth,
      template: PHOTO_TRIO_PAGE_WIDTH_DEFAULT,
    },
    noPhoto: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.noPhoto,
      template: NO_PHOTO_DEFAULT,
    },
    photoArch: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoArch,
      template: PHOTO_ARCH_DEFAULT,
    },
    photoDuoLeft: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoDuoLeft,
      template: PHOTO_DUO_LEFT_DEFAULT,
    },
    photoDuoRight: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoDuoRight,
      template: PHOTO_DUO_RIGHT_DEFAULT,
    },
    photoMarquee: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoMarquee,
      template: PHOTO_MARQUEE_DEFAULT,
    },
    photoMarqueePageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarqueePageWidth-v1_0_0.json',
      template: PHOTO_MARQUEE_PAGE_WIDTH_DEFAULT,
    },
    photoBackground: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoBackground,
      template: PHOTO_BACKGROUND_DEFAULT,
    },
    photoBackgroundMonogram: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.photoBackgroundMonogram,
      template: PHOTO_BACKGROUND_MONOGRAM_DEFAULT,
    },
    videoBackground: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.videoBackground,
      template: VIDEO_BACKGROUND_DEFAULT,
    },
    videoBackgroundMonogram: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.videoBackgroundMonogram,
      template: VIDEO_BACKGROUND_MONOGRAM_DEFAULT,
    },
    videoArch: {
      schemaUrl: SCHEMA_URL_BY_WEBSITE_LAYOUT.brannan.videoArch,
      template: VIDEO_ARCH_DEFAULT,
    },
  },
};
